import React from 'react';
import { Icon } from './Icon.jsx';

/** Checkbox — rounded box that fills folk-green when checked. Controlled or uncontrolled. */
export function Checkbox({ label, checked, defaultChecked, onChange, disabled, id, ...rest }) {
  const generatedId = React.useId();
  const rid = id || generatedId;
  const [internal, setInternal] = React.useState(!!defaultChecked);
  const isControlled = checked !== undefined;
  const on = isControlled ? checked : internal;

  const toggle = () => {
    if (disabled) return;
    if (!isControlled) setInternal(v => !v);
    onChange?.(!on);
  };

  return (
    <label htmlFor={rid} style={{
      display: 'inline-flex', alignItems: 'center', gap: 10,
      cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
      fontFamily: 'var(--font-sans)', fontSize: 'var(--text-base)', color: 'var(--text-body)',
    }}>
      <input id={rid} type="checkbox" checked={on} onChange={toggle} disabled={disabled}
        style={{ position: 'absolute', opacity: 0, width: 1, height: 1 }} {...rest} />
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 24, height: 24, borderRadius: 'var(--radius-sm)',
        background: on ? 'var(--success)' : 'var(--surface-card)',
        border: `2px solid ${on ? 'var(--success)' : 'var(--border-strong)'}`,
        transition: 'background var(--dur-fast) var(--ease-out), border-color var(--dur-fast) var(--ease-out)',
        flex: 'none',
      }}>
        {on && <Icon name="check" size={16} color="#fff" strokeWidth={3} />}
      </span>
      {label}
    </label>
  );
}
